import ufeApi from 'services/api/ufeApi';
import Empty from 'constants/empty';
import getSotTrackingId from 'ai/utils/getSotTrackingId';

const path = '/gway/v1/p13n/content';

function getP13nNbcData({
    channel, country, language, atgId, contextEntryIds = Empty.Array, zipCode
}) {
    const apikey = Sephora.configurationSettings.sdnUfeAPIUserKey;

    // Support multiple context IDs by concatenating them with commas
    const entryIds = contextEntryIds.join(',');
    let queryParams = `/${entryIds}?atg_id=${atgId}&channel=${channel}&locale=${language}-${country}`;

    if (zipCode) {
        queryParams += `&zipcode=${zipCode}`;
    }

    const sotTrackingId = getSotTrackingId();

    if (sotTrackingId) {
        queryParams += `&sotTrackingId=${encodeURIComponent(sotTrackingId)}`;
    }

    const url = `${path}${queryParams}`;

    return ufeApi
        .makeRequest(url, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'x-api-key': apikey
            }
        })
        .then(({ data = Empty.Array, errorCode }) => {
            if (errorCode) {
                return Promise.reject(data);
            }

            return data;
        });
}

export default getP13nNbcData;
